// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"53047c00","151":"1117e9a6","541":"72c60f08","626":"fac66230","787":"d51d586a","803":"22f6f2a2","880":"690c216c","945":"8a5ef3d7"}[chunkId] + ".chunk.js";
};